
const serverURL = 'https://serverbestforce.deltabyte.com.br'


export default serverURL
